import { FloatingControlComponent, SearchSelectComponent } from "../FormComponent";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { formatInputDate } from "../../utils/Time";

function HeadDetail({ field, data, disableAll }) {
    const headData = [data]?.map((ele) => ({
        tech_mas_name: ele.tech_mas_name,
        contract_no: ele.SeqOthersJob?.InformOtherJob?.Contract_No,
        contract_type: "",
        start_contract: "",
        end_contract: "",
        sup_team: ele.SeqOthersJob?.InformOtherJob?.Sub_Team,
        project_no: ele.SeqOthersJob?.InformOtherJob?.Project_No,
        start: ele?.Job_Cus_Date, //formatInputDate(ele?.Job_Cus_Date, "Local")?.date,
        status_: "",
        cus_code: ele.Cus_Code,
        cus_no: ele.SeqOthersJob?.InformOtherJob?.Cus_NumBranch,
        cus_name: ele.Cus_Name,
    }))

    return (
        <Col as={Row} className="mb-3">
            <ShowBoxData
                field={field || []}
                data={headData[0]}
                disableAll={disableAll}
            />
        </Col>
    )
}
HeadDetail.propTypes = {
    field: PropTypes.array.isRequired,
    data: PropTypes.object,
    disableAll: PropTypes.bool
};

const ShowBoxData = ({ field, data, disableAll, searchCallback, searchByField }) => {
    // const [searchData, setSearchData] = useState(field);
    const setDateBetween = (search) => {
        console.log(search)
        // search?.filter(
        //     ({ name, type }) =>
        //         type === "date" &&
        //         ["START", "END", "createdAt", "updatedAt"].some((suffix) =>
        //             name.toUpperCase().includes(suffix.toUpperCase())
        //         )
        // );
    }

    const handleChange = (name, value, queryService) => {
        // const updatedData = searchData?.map((item) =>
        const updatedData = data?.map((item) =>
            item.name === name ? { ...item, value } : { ...item, noneAsync: true }
        );

        // if (queryService) {
        //     const [start, end] = setDateBetween(updatedData);
        //     const searchStart = start?.value ? `&start=${start?.value}` : "";
        //     const searchEnd = end?.value ? `&end=${end?.value}` : "";
        //     queryService(`?limit=1000${searchStart}${searchEnd}`);
        // }
        console.log(updatedData, queryService)
        return searchCallback(updatedData);
        if (searchByField?.name == name) {
            searchCallback(checkIsVal(newData?.Filter?.Array) ? { ...newData?.Filter?.Array[0], page: 1 } : "");
        } else {
            searchByField.queryService(
                checkIsVal(newData?.Filter?.Array) ? { ...newData?.Filter?.Array[0] } : {}
            )
        }
    };
    function checkIsVal(Array) {
        let isVal = 0
        Array.map((el) => {
            const val = (Object.values(el))[0]
            if (val) isVal += 1
        })
        return isVal
    }

    return (disableAll ? field : data)?.map(
        (
            { name, label, size, classNames, style, value, disabled, type, filterBy, noneAsync, minKeywordLength, options, queryService, required },
            index
        ) => {
            const Value = (
                disableAll ? (value || data ? data[name] : "")
                    : data[index].value
            ) || field[index].value

            return (
                <Col
                    key={index}
                    sm={size ? size : size === null ? null : 3}
                    className={classNames?.col || "mb-3"}
                >
                    {name && (
                        type === "select" ? (
                            <div className={!required && "noValidGreen"}>
                                <SearchSelectComponent
                                    labelField={label}
                                    filterBy={filterBy}
                                    disabled={disabled}
                                    noneAsync={noneAsync}
                                    placeholder="ทั้งหมด"
                                    minKeywordLength={minKeywordLength}
                                    options={options || []}
                                    queryService={queryService}
                                    isInvalid={required}
                                    onChange={(change) =>
                                        handleChange(name, change?.value, options)
                                    }
                                    value={Value}
                                />
                            </div>
                        ) : <div className={!required && "noValidGreen"}>
                            <FloatingControlComponent
                                // readOnly
                                type={type}
                                name={name}
                                label={label}
                                className={classNames}
                                style={style}
                                value={Value}
                                disabled={disableAll || disabled}
                                onChange={e => handleChange(name, e.target.value)}
                                required={required}
                            />
                        </div>
                    )}
                </Col>
            );
        }
    );
};

export {
    HeadDetail,
    ShowBoxData
}